module.exports = __webpack_public_path__ + "media/images/report_areas/gaic-9988df42a76e310ffd01eaa999a6436f.bmp";